import { useState, useEffect } from 'react';

import * as Avatar from '@radix-ui/react-avatar';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ExitIcon, PersonIcon, Component1Icon } from '@radix-ui/react-icons';

const apiUrl = import.meta.env.VITE_API_BASE_URL;

function AuthHeader({ user,  setUser, setUserCredits, setIsLoadingAuth  }: { }) {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const checkLoginStatus = async () => {
      setIsLoadingAuth(true);

      let isLoggedInCookie;

      try {
        isLoggedInCookie = document.cookie
          .split('; ')
          .find(row => row.startsWith('_grape_graph_user_logged_in='));
      } catch (error) {
        ifLoggedInCookie = false;
      }

      if (isLoggedInCookie) {
        try {
          // If the cookie exists, fetch the user details
          const response = await fetch(`${apiUrl}/api/auth_status`, {
            credentials: 'include' // Important: sends cookies with the request
          });

          if (response.ok) {
            const data = await response.json();

            setUserCredits(data.user_credits);
            if (data.authenticated) {
              setUser(data);
            }
          }
        } catch (error) {
          console.error('Error fetching auth status:', error);
        }
      }
      
      setLoading(false);
      setIsLoadingAuth(false);
    };
    
    checkLoginStatus();
  }, []);

  return (
    <div className="auth-header">
      {user ? (
        <UserAvatarMenu user={user} />
      ) : (
        <div>
          <a className="px-5 py-3 rounded-lg font-medium transition-all bg-purple-600 text-white hover:bg-purple-700 mr-3" href={`${apiUrl}/users/register`}>Sign up</a> 
          <a className="ring-1 ring-purple-700 px-5 py-2.5 rounded-lg font-medium transition-all bg-white/20 backdrop-blur-sm hover:bg-purple-100 text-purple-700 border border-gray-200" href={`${apiUrl}/users/log_in`}>Login</a>
        </div>
      )}
    </div>
  );
}

function UserAvatarMenu({ user }) {
  // Get first letter of username for avatar
  const initial = user.username ? user.username.charAt(0).toUpperCase() : '?';

  const handleDashboard = () => {
    // Redirect to the dashboard
    window.location.href = `${apiUrl}/avatars`;
  }
  
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button 
          className="outline-none"
          aria-label="User menu"
        >
          <Avatar.Root className="bg-purple-600 inline-flex h-10 w-10 select-none items-center justify-center overflow-hidden rounded-full align-middle">
            <Avatar.Fallback className="text-white text-sm font-medium">
              {initial}
            </Avatar.Fallback>
          </Avatar.Root>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content 
          className="min-w-[220px] bg-white rounded-lg p-2 shadow-lg z-50"
          sideOffset={5}
          align="end"
        >
          <DropdownMenu.Item className="flex items-center h-10 px-3 text-sm rounded-md outline-none cursor-default text-gray-700 focus:bg-purple-100">
            <PersonIcon className="w-4 h-4 mr-2 text-purple-600" />
            <span className="truncate">{user.email || user.username}</span>
          </DropdownMenu.Item>
          
          <DropdownMenu.Separator className="h-px m-1 bg-gray-200" />

          <DropdownMenu.Item 
            className="flex items-center h-10 px-3 text-sm rounded-md outline-none cursor-default text-gray-700 focus:bg-purple-100"
            onSelect={handleDashboard}
          >
            <Component1Icon className="w-4 h-4 mr-2 text-purple-600" />
            <span>Avatars</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

export default AuthHeader;
